import { createFileRoute } from "@tanstack/react-router";
import { CelebrityResultPage } from "@/components/site/CelebrityResultPage";
import { deionSanders } from "@/lib/celebrity-results/deion-sanders";
import { absoluteUrl } from "@/lib/absolute-url";

const TITLE = "Deion Sanders Hair Transplant Results | RESTORE Hair";
const DESC = "Coach Deion Sanders trusted RESTORE with his hair transplant. See what a successful hair restoration journey looked like for Deion Sanders.";
// Parity options. The h1 stays "Deion Sanders's Hair Restoration Story with RESTORE".
const WP = {
  // Links in the WordPress story text. The two old coach-deion-sanders-* URLs now redirect to /deion-sanders-hair-transplant/.
  links: [
    { text: "Sanders tried different hair loss solutions throughout the years", href: "/deion-sanders-hair-transplant/" },
    { text: "Brian Urlacher", href: "/brian-urlachers-tackling-balding-with-restore/" },
    { text: "Brian\u2019s a friend", href: "/deion-sanders-hair-transplant/" },
    { text: "FUE transplant", href: "/deion-sanders-hair-transplant/" },
    { text: "talking about his new hairline", href: "/deion-sanders-hair-transplant/" },
    { text: "It\u2019s brought my swagger back", href: "/deion-sanders-hair-transplant/" },
  ],
};
const POSTER = "/img/r/wp-2023-11-restore-seamless-hr-5321-v2-copy-1kraked-new-1.webp";

export const Route = createFileRoute("/results/deion-sanders")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "article" },
      { property: "og:url", content: "https://restorehair.com/results/deion-sanders/" },
      { property: "og:image", content: absoluteUrl(POSTER) },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: absoluteUrl(POSTER) },
    ],
    links: [
      { rel: "canonical", href: "https://restorehair.com/results/deion-sanders/" },
    ],
  }),
  component: () => <CelebrityResultPage data={deionSanders} wp={WP} />,
});
